<template>
  <transition name="fade">
    <div class="nd-mask" :style="{ 'z-index': zIndex }" @click="clickHandler" v-if="visible"></div>
  </transition>
</template>
<script>
export default {
  name: 'nd-mask',

  props: {
    onMaskClick: {
      type: Function,
      default: () => {}
    },
    zIndex: {
      type: Number,
      default: 999
    }
  },

  data () {
    return {
      visible: false
    }
  },

  methods: {
    destroyElement () {
      this.$el.removeEventListener('animationend', this.destroyElement)
      this.$el.parentNode.removeChild(this.$el)
      this.$destroy(true)
    },

    clickHandler (...arg) {
      // eslint-disable-next-line no-useless-call
      this.onMaskClick.apply(this, [this, ...arg])
    },

    open () {
      this.visible = true
    },

    close () {
      this.visible = false
      this.$el.addEventListener('animationend', this.destroyElement)
    },

    hide () {
      this.visible = false
    },

    show () {
      this.visible = true
    },

    remove () {
      this.visible = false
      this.destroyElement()
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .nd-mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.7);
    }

    .fadeIn {
        animation: fadeIn .3s linear;
    }

    .fadeOut {
        animation: fadeOut .3s linear;
    }

    .fade-enter-active {
        .fadeIn
    }

    .fade-leave-active {
        .fadeOut
    }
</style>